import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=87c4941c&scoped=true&"
import script from "./Alerts.js?vue&type=script&lang=js&"
export * from "./Alerts.js?vue&type=script&lang=js&"
import style0 from "./Alerts.css?vue&type=style&index=0&id=87c4941c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c4941c",
  null
  
)

export default component.exports